<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="POS Devices"
            bc3="Add"
            path="pos-devices"
          ></Breadcrumb>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >

        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                  type="text"
                                  id="rate-icon"
                                  class="form-control"
                                  v-model="name"
                                  name="name"
                                  placeholder="Name (optional)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <select class="form-control" v-model="type">
                                <option value="1">POS</option>
                                <option value="2">SoftPOS</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="isSoftPOS">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="noOfDevices">No. of Devices</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                type="number"
                                id="noOfDevices"
                                class="form-control"
                                v-model="noOfDevices"
                                name="noOfDevices"
                                min="1"
                                max="50"
                                placeholder="No. of Devices (optional)"
                                :class="
                                  errorBag.has('noOfDevices') ? 'is-invalid' : ''
                                "
                                v-validate="'integer|min_value:1|max_value:50'"
                              />
                              <small
                                v-show="errorBag.has('noOfDevices')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("noOfDevices") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <template v-else>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Device Model</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                  type="text"
                                  id="rate-icon"
                                  class="form-control"
                                  v-model="posDeviceModel"
                                  name="name"
                                  placeholder="Device Model"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Device ID</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon/> </span>
                              </div>
                              <input
                                type="text"
                                v-model="deviceId"
                                class="form-control"
                                :class="
                                  errorBag.has('deviceId') ? 'is-invalid' : ''
                                "
                                name="deviceId"
                                placeholder="Device ID"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('deviceId')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("deviceId") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="rate-icon">IMEI Number</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                type="text"
                                id="rate-icon"
                                class="form-control"
                                v-model="imeiNumber"
                                name="imeiNumber"
                                placeholder="IMEI"
                                :class="
                                  errorBag.has('imeiNumber') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('imeiNumber')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("imeiNumber") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="rate-icon">Serial Number</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                type="text"
                                id="code-icon"
                                class="form-control"
                                v-model="serialNumber"
                                name="serialNumber"
                                placeholder="Serial Number"
                                :class="
                                  errorBag.has('serialNumber') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('serialNumber')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("serialNumber") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      </template>
                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$router.push({ name: 'pos-devices' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { TargetIcon, Edit3Icon, CommandIcon } from "vue-feather-icons";
export default {
  components: {
    TargetIcon,
    Edit3Icon,
    CommandIcon
  },
  mounted() {},
  data() {
    return {
      deviceId: '',
      imeiNumber: '',
      serialNumber: '',
      posDeviceModel:'',
      name: '',
      type: 1,
      noOfDevices: '',
      loading: false,
      size: "10px"
    };
  },
  computed: {
    isSoftPOS() {
      return this.type == 2;
    }
  },
  methods: {
    onFileChanged(event) {
      this.logo = event.target.files[0];
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = this.isSoftPOS
            ? {
                name: this.name,
                type: this.type,
                ...(this.noOfDevices !== '' && { noOfDevices: Number(this.noOfDevices) })
              }
            : {
                name: this.name,
                posDeviceId: this.deviceId,
                imeiNumber: this.imeiNumber,
                serialNumber: this.serialNumber,
                posDeviceModel: this.posDeviceModel,
                type: this.type
              }
          this.makeRequest("post", "v1/create-pos-device", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  this.$router.back()
                }
              }
              this.loading = false;
            }
          );
        }
      });
    }
  }
};
</script>

